import type { FC } from 'react';
import React from 'react';
import type { NodeProps } from '../../types';
import StartNodeDefault from './default';
import StartNodeIcon from './icon';
import type { StartNodeType } from './types';
const Node: FC<NodeProps<StartNodeType>> = ({ id, data }) => {
  return null
  return (
    <div className="flex items-center gap-2">
      <StartNodeIcon className="size-6" />
      <span>{data?.title || StartNodeDefault.name}</span>
    </div>
  );
};

export default React.memo(Node);
